export enum OrganizationType {
  HyundaiMobis = 14,
  Mobius = 105,
  Hanjin = 136,
  HyundaiCarLXP = 83
}
